// react components
import React, {
    useState,
} from 'react'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
    media_url_site,
} from 'data'

// props
type NotFoundComponent825Props = {
    statusCode?: number
}

// main
export const NotFoundComponent825: React.FC<NotFoundComponent825Props> = React.memo(({
    statusCode,
}) => {

    const reduxAuth = useSelector((state: defaultReduxState) => state.reduxAuth)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [backgroundImage] = useState<string>(`${media_url_site}global/not-found/dark/${Math.floor(Math.random() * 13)}.jpeg`)

    const statusText: any = {
        403: reduxAuth?.authenticated ? reduxText[10217] : reduxText[10218],
        404: reduxText[10219],
    }

    return (
        <div
            className='not-found-component-825'
            style={{
                backgroundImage: `url('${backgroundImage}')`
            }}
        >
            <div className='nfc-wrap'>
                <p className='nfc-text1'>{statusCode || 404}</p>
                <p className='nfc-text2'>{statusCode ? statusText[statusCode] : reduxText[10219]}</p>
            </div>
        </div>
    )
})
